import { createSelector } from 'reselect';
import { leaderboardSelector } from './simple-selectors';

export const leaderboardRequestsSelector = createSelector(
    leaderboardSelector,
    (leaderboard) => leaderboard.requests
);
